import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import Subheader from 'material-ui/Subheader';

class App extends Component {
  render() {
    return (
      <div>
        <AppBar title="Fallacy.io" />
        <Subheader>Ad Hominem</Subheader>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js